// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"391":"15573f6f","618":"b1a77fb2"}[chunkId] + ".chunk.css";
};